import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DISCOUNTS_AND_GIFTCARDS: "Rabattkoder og gavekort",
      YOUR_LOYALTY_LEVEL: "Ditt lojalitetsnivå",
      REDEEM: "Legg til",
      DISCOUNT_CODE: "rabattkode",
      GIFTCARD: "gavekort",
      REDEEM_DISCOUNTS_AND_GIFTCARDS: "Legg til rabattkode eller gavekort",
      YOUR: "Dine",
      WHEN_IS_MY_DISCOUNT_DEDUCTED: "Når trekkes rabatten min?",
      DESCRIPTION_HOW_DISCOUNT_DEDUCTED:
        "Rabatten trekkes fra når ordren låses, tirsdag 23:59 før levering. Vi velger den siste rabatten du har lagt til hvis produktene du har valgt oppfyller kravene for rabatten. Har du gavekort trekkes det ved neste levering.",
      YOUR_REBATES: "Dine rabatter",
      DEDUCTED_ON_NEXT_DELIVERY: "Trekkes ved neste levering",
      UPCOMING_DISCOUNT: "Kommende rabatter",
      EXPIRED_DISCOUNT_AND_GIFTCARDS: "Utløpte rabatter og gavekort",
      YOU_CURRENTLY_HAVE_NO_DISCOUNTS_OR_GIFTCARDS:
        "Du har for tiden ingen aktive rabatter eller gavekort.",
    },

    se: {
      DISCOUNTS_AND_GIFTCARDS: "Rabattkoder & presentkort",
      YOUR_LOYALTY_LEVEL: "Din lojalitetsnivå",
      REDEEM: "Lös in",
      DISCOUNT_CODE: "rabattkod",
      GIFTCARD: "presentkort",
      REDEEM_DISCOUNTS_AND_GIFTCARDS: "Lös in rabattkod eller presentkort",
      YOUR: "Dina",
      WHEN_IS_MY_DISCOUNT_DEDUCTED: "När dras min rabatt?",
      DESCRIPTION_HOW_DISCOUNT_DEDUCTED:
        "Rabatten dras av när beställningen är låst, tisdag 23:59 före leverans. Vi väljer den senaste rabatten du lagt till om de produkter du valt uppfyller kraven för rabatten. Om du har ett presentkort, dras det vid nästa leverans.",
      YOUR_REBATES: "Dina rabatter",
      DEDUCTED_ON_NEXT_DELIVERY: "Dras vid nästa leverans",
      UPCOMING_DISCOUNT: "Kommande rabatter",
      EXPIRED_DISCOUNT_AND_GIFTCARDS: "Förfallna rabatter och presentkort",
      YOU_CURRENTLY_HAVE_NO_DISCOUNTS_OR_GIFTCARDS:
        "Just nu har du inga aktiva rabatter eller presentkort.",
    },

    dk: {
      DISCOUNTS_AND_GIFTCARDS: "Rabatkoder og gavekort",
      YOUR_LOYALTY_LEVEL: "Dit loyalitetsniveau",
      REDEEM: "Indløs",
      DISCOUNT_CODE: "rabatkode",
      GIFTCARD: "gavekort",
      REDEEM_DISCOUNTS_AND_GIFTCARDS: "Indløs rabatkode eller gavekort",
      YOUR: "Dine",
      WHEN_IS_MY_DISCOUNT_DEDUCTED: "Hvornår trækkes min rabat?",
      DESCRIPTION_HOW_DISCOUNT_DEDUCTED:
        "Rabatten fratrækkes, når ordren er låst, onsdag 23:59 før levering. Vi vælger den sidste rabat, du har tilføjet, hvis de produkter, du har valgt, opfylder kravene til rabatten. Har du et gavekort, trækkes det ved din næste levering.",
      YOUR_REBATES: "Dine rabatter",
      DEDUCTED_ON_NEXT_DELIVERY: "Aktive rabatter og gavekort",
      UPCOMING_DISCOUNT_AND_GIFTCARDS: "Kommende rabatkoder og gavekort",
      EXPIRED_DISCOUNT_AND_GIFTCARDS: "Udløbet",
      YOU_CURRENTLY_HAVE_NO_DISCOUNTS_OR_GIFTCARDS:
        "Du har lige nu ingen aktive rabatter eller gavekort.",
    },
  } as const
)[language];
